export const memberStatus = {
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    PUBLISHED: "PUBLISHED",
    PUBLISH_IN_PROGRESS: "PUBLISH_IN_PROGRESS",
    VERIFIED: "VERIFIED",
    EXPIRED: "EXPIRED",
};
